/* eslint-disable max-len */
/* eslint-disable max-statements */
/* eslint-disable no-prototype-builtins */

export default function () {
  window.getArrayOfComponentsFromPageDef = function (pageDef) {
    let ret = [];

    if (pageDef.hasOwnProperty('type') && pageDef.hasOwnProperty('id')) {
      ret = [...ret, pageDef];
    }
    if (Object.keys(pageDef).length) {
      for (let i = 0; i < Object.keys(pageDef).length; i++) {
        const value = pageDef[Object.keys(pageDef)[i]];
        if (typeof value === 'object' && value !== null) {
          const o = window.getArrayOfComponentsFromPageDef(pageDef[Object.keys(pageDef)[i]]);
          if (o !== null && o instanceof Array) {
            ret = [...ret, ...o];
          }
        }
      }
    }
    return ret;
  };
}
